const VALIDATION_VOTE = {
  APPROVED: 'Goedgekeurd',
  REJECTED: 'Afgekeurd',
}

module.exports = {
  VALIDATION_VOTE,
}
